import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { coachRatingsRequest, coachRatingsSuccess, coachRatingsFailure } from '../reducers/coachRatings';
import { API_LINK } from '../../constants';
import { setCoachRatingQuality } from '../reducers/userProgramsFull';
import {getSelectedThinktool} from '../selectors'

const API = `${API_LINK}api/coachRating`;

function* coachRatingAxios() {

  const state = yield select(fullState => fullState);

  const coachId = state.loginReducer.user.userId;
    const {
      token,
    } = state.loginReducer;

  const {
    coachRating,
    coachRatingQuality,
    coachRatingComment,
    coachRatingVersion,
    selectedUserId,
    selectedVersionId,
    selectedModuleId,
    selectedRollout

  } = state.userProgramsFullReducer;
  console.log('XXX2', state.userProgramsFullReducer)
  var comment = 'no comment'
  if(coachRatingComment!=''){
     comment = coachRatingComment
  }
  const response = yield call(() => {

  return axios({
    method: 'post',
    url: API,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
   
    credentials: 'same-origin',
    data: {
      coach_id: coachId, 
      user_id: selectedUserId,
      version_id: selectedVersionId, 
      coach_rating: coachRatingQuality, 
      coach_quality: coachRating,
      coach_comment: comment,
      module_id: selectedModuleId,
      rollout_id: selectedRollout
    },
  });
});

  return response;
}

function* workerCoachRatingSaga() {
  try {
    const response = yield call(coachRatingAxios);
    const responseFromcoachRating = response.data;

    yield put(coachRatingsSuccess(responseFromcoachRating));
    if (response.status === 500) {
      yield put(coachRatingsFailure(responseFromcoachRating));
    }
  } catch (error) {
    yield put(coachRatingsFailure(error));
  }
}

export function* watchercoachRatingSaga() {
  yield takeLatest(coachRatingsRequest().type, workerCoachRatingSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_coachrating.js